import Splide from "@splidejs/splide";
// import "@splidejs/splide/css/core"; // Imported in vendor

/**
 * Splide
 */
const splide = () => {
    let $splides,
        $splide,
        $pagination,
        $contents,
        id,
        instance,
        options,
        optionsOverride;

    const initSplide = (type, optionsDefault) => {
        $splides = $(`.splide--${type}`);
        if (!$splides.length) return;

        $splides.each((index, target) => {
            $splide = $(target);
            id = `${type}-${index}`;
            $splide.attr("data-splide-id", id);

            optionsOverride = JSON.parse($splide.attr("data-config") ?? null);
            options = { ...optionsDefault, ...optionsOverride };
            $splide.removeAttr("data-config");

            instance = new Splide(`[data-splide-id="${id}"]`, options);

            if (options.pagination) {
                $pagination = $splide.find("[data-splide-pagination]");
                $contents = $pagination.find("li");

                instance.on("pagination:mounted", (data) => {
                    data.items.forEach((item) => {
                        item.button.innerHTML = $contents[item.page].innerHTML;
                    });
                });

                $pagination.remove();
            }

            // Patch - Remove focus of other siblings on hover to prevent multiple visible hover appearances
            $splide.find(".splide__slide").on("mouseover", ({ currentTarget }) => {
                $(currentTarget).siblings().find("a").trigger("blur");
            });

            instance.mount();
        });
    }

    // Initiate Splides
    initSplide("default", {
        focus: "left",
        type: "loop",
        updateOnMove: true,
        pagination: false,
        rewind: true,
        rewindSpeed: 0,
        rewindByDrag: true,
    });

    initSplide("center", {
        focus: "center",
        type: "loop",
        updateOnMove: true,
        pagination: false,
        rewind: true,
        rewindSpeed: 0,
        rewindByDrag: true,
    });

    // initSplide("foo", {
    //     // options
    // });
}

$(splide);

export default splide;
